import {
 Component,
 ElementRef,
 HostListener,
 OnInit,
 Renderer2,
 ViewChild,
} from "@angular/core";
import { ThemeOptions } from "../../../../../theme-options";
import { select } from "@angular-redux/store";
import { Observable } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../../../environments/environment";
import { KeycloakService } from "keycloak-angular";
import { LanguageService } from "../../../../../Shared/Services/language.service";
import { BehaviorSubject } from "rxjs";
import {
 EcritureComptableComponent
} from "../../../../../Pages/accounting/ecriture-comptable/ecriture-comptable.component";
import {EcritureComponent} from "../../../../../Pages/accounting/ecriture/ecriture.component";
import { ReservationService } from "app/Shared/Services/reservation.service";
@Component({
 selector: "app-sidebar",
 templateUrl: "./sidebar.component.html",
 styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
 isNavbarCollapsed = true;
 index: number = 0;
 indexBack: number | null = null;

 isMenuOpen: boolean = false;
 groupId: any;
 comptaSubMenuOpen: boolean = false;
 ReconcilliationSubMenuOpen:boolean = false;
 CrmSubMenuOpen: boolean = false;

 toggleMenu() {
 this.isMenuOpen = !this.isMenuOpen;
 }
 searchText: string = "";
 Disabled: number[] = [];
 urlBookBeds = environment.urlbookbeds;
 urlCRM = environment.urlcrm;
 indexo: any = undefined;
 User: any = undefined;
 checked: boolean = false;
 selectedIndex: number | null = null;
 isSidebarVisible: boolean = true; 

 selectedListItemIndex: number | null = null;
 showedChaifer:boolean = false;
 EventNew : any = {
 user:null,
 groupId:0,
 type:null,
 message:null,
 priority:"Critical",
 itemId:null,
 detail:null,
 itemNumber:null,
 }
 // sideBarMatrix:any = [
 // // [
 // // {icon:'book_online',name:'Réservations et types',route:''},
 // // {icon:'show_chart',name:'Clients et revenus',route:'front-desk/dashboard/clients'},
 // // {icon:'fullscreen',name:'Indicateur des chambres',route:'front-desk/plan-2d'},
 // // {icon:'room_preferences',name:'chambres',route:'room-options'},
 // // {icon:'local_shipping',name:'équipements',route:'room-options/equipements'},
 // // {icon:'donut_large',name:'Dashboard',route:'/front-desk/dashboard'},
 // // {icon:'published_with_changes',name:'Check-in',route:'/front-desk/check-in',notifications:25},
 // // {icon:'price_check',name:'Check-out',route:'/front-desk/check-out',notifications:10},
 // // {icon:'date_range',name:'Calendrier des cha...',route:'/front-desk/rooms'},
 // // {icon:'engineering',name:'Rendez-vous',route:'front-desk/rendez-vous'},
 // // {icon:'emoji_objects',name:'Perdu et trouvé',route:'/front-desk/lost&found'},
 // // {icon:'task',name:'Interventions',route:'/front-desk/tasks'},
 // // {icon:'task',name:'Statistiques interventions',route:'/front-desk/interventions/bilan'},
 // // {icon:'cleaning_services',name:'Entretien ménager',route: 'house-keeping/house-maids-interventions'},
 // // {icon:'manage_accounts',name:'Femmes de ménage',route: 'house-keeping/house-maids'},
 // // {icon:'group_add',name:'Groupes de ménage',route: 'house-keeping/house-maids-groupes'},
 // // {icon:'tune',name:'Paramétres de ménage',route: 'house-keeping/house-maids-parametres'},
 // // {icon:'event',name: 'Calendrier de ménage',route: 'house-keeping/calendar-clean'},
 // // {icon:'warning_amber',name: 'Ménage urgent',route: 'house-keeping/urgent-clean'},
 // // ],

 //selectedListItemIndex:number | null = null; 
 
// sideBarMatrix:any = [
// // [
// // {icon:'book_online',name:'Réservations et types',route:''},
// // {icon:'show_chart',name:'Clients et revenus',route:'front-desk/dashboard/clients'},
// // {icon:'fullscreen',name:'Indicateur des chambres',route:'front-desk/plan-2d'},
// // {icon:'room_preferences',name:'chambres',route:'room-options'},
// // {icon:'local_shipping',name:'équipements',route:'room-options/equipements'},
// // {icon:'donut_large',name:'Dashboard',route:'/front-desk/dashboard'},
// // {icon:'published_with_changes',name:'Check-in',route:'/front-desk/check-in',notifications:25},
// // {icon:'price_check',name:'Check-out',route:'/front-desk/check-out',notifications:10},
// // {icon:'date_range',name:'Calendrier des cha...',route:'/front-desk/rooms'},
// // {icon:'engineering',name:'Rendez-vous',route:'front-desk/rendez-vous'},
// // {icon:'emoji_objects',name:'Perdu et trouvé',route:'/front-desk/lost&found'},
// // {icon:'task',name:'Interventions',route:'/front-desk/tasks'},
// // {icon:'task',name:'Statistiques interventions',route:'/front-desk/interventions/bilan'},
// // {icon:'cleaning_services',name:'Entretien ménager',route: 'house-keeping/house-maids-interventions'},
// // {icon:'manage_accounts',name:'Femmes de ménage',route: 'house-keeping/house-maids'},
// // {icon:'group_add',name:'Groupes de ménage',route: 'house-keeping/house-maids-groupes'},
// // {icon:'tune',name:'Paramétres de ménage',route: 'house-keeping/house-maids-parametres'},
// // {icon:'event',name: 'Calendrier de ménage',route: 'house-keeping/calendar-clean'},
// // {icon:'warning_amber',name: 'Ménage urgent',route: 'house-keeping/urgent-clean'}, 
// // ],


 // //Back-office

 // //Reservation
 // [
 // {icon:'dashboard',name:'Dashboard Admin',route:'/main/dashboardAdmin'},
 // {icon:'add_circle',name:'New Reservation',route:'/front-desk/reservations-management'},
 // {icon:'update',name:'Update Reservation',route:'/front-desk/reservationslist'},
 // // [{icon:'how_to_reg',name:'Create Customer',route:'/front-desk/CustomerMr'},
 // // {icon:'library_add',name:'Reservation',route:'/front-desk/Group-Reservations'},
 // // ]

 // ],
 // //Front Desk
 // [
 // {icon:'check_circle',name:'Check In',route:'/front-desk/check-in'},
 // {icon:'home',name:'in House',route:'/front-desk/in-House'},
 // {icon:'exit_to_app',name:'Check Out',route:'/front-desk/check-out'},
 // {icon:'cancelation',name:'Cancellation & No Show',route:'/front-desk/Cancellation&Noshow'},
 // {icon:'person',name:'Guest Profiles',route:'/front-desk/guest'},
 // {icon:'payment',name:'List Payments',route:'/front-desk/List-Payments'}
 // // {icon:'home',name:'Room Assignement',route:'/front-desk/in-House'},
 // // {icon:'room',name:'Tracking Room Status',route:'/front-desk/check-out'},
 // // {icon:'receipt',disabled: true,name:'Generating Gest Invoice',route:'/front-desk/in-House'},

 // ],
 // [
 // // here i want just to wase like menu and sous meny i want when i click to menu he open to me the list of menu inside this menu
 // //i want tree principale menu first for parameter
 // {icon:'add_product',name: 'Create Product',route: '/front-desk/BackOfice/Products'},
 // {icon:'list',name: 'List Product',route: '/front-desk/BackOfice/list'},
 // // and for the second menu for traitement i want this in sous menu
 // {icon: 'add_circle',name: 'Add Stock',route: '/front-desk/BackOfice/InternalOrder'},
 // { icon: 'assignment', name: 'Create Order Supplier', route: '/front-desk/BackOfice/OrderSuplier' },
 // {icon:'spellcheck',name: "Validation of Purchase Orders",route: '/front-desk/BackOfice/achat'},
 // {icon:'request_quote',name: "Delivery",route: '/front-desk/BackOfice/delivery'},
 // {icon:'check',name: "Control",route: '/front-desk/BackOfice/ValidateOrderInternal'},
 // {icon: 'credit_score', name: "Confirm Delivery", route: '/front-desk/BackOfice/confirm-delivery' },
 // {icon: 'swap_horizontal_circle', name: "Movement of Stock", route: '/front-desk/BackOfice/StockStatus' },
 // {icon: 'dashboard', name: "Stock", route: '/front-desk/BackOfice/stocks' },
 // {icon: 'edit', name: "Stock Correction", route: '/front-desk/BackOfice/CorrectionStock' },
 // // and for menu of rapport i want this in the sous menu
 // {icon: 'dashboard', name: "Stock", route: '/front-desk/BackOfice/stocks' },
 // {icon: 'table-properties', name: "Board", route: '/front-desk/BackOfice/Editing' },
 // {icon: 'euro_symbol', name: "Consumption", route: '/front-desk/BackOfice/Consommation' },
 // {icon: 'compare_arrows', name: "Cardex", route: '/front-desk/BackOfice/transactionstock' },
 // ],
 // //Houskeeping RoomStatus
 // [
 // {
 // icon: 'room_preferences',
 // name: 'Configuration',
 // route: 'room-options',
 // children: [
 // { icon: 'room_preferences', name: 'Chambres', route: 'room-options' },
 // { icon: 'manage_accounts', name: 'Femmes de Chambres', route: 'house-keeping/house-maids' }
 // ]
 // },
 // { icon: 'room_status', name: 'Room Status', route: 'front-desk/RoomStatus' },

 // // {icon:'fullscreen',name:'Indicateur des chambres',route:'front-desk/plan-2d'},
 // // {icon:'local_shipping',name:'équipements',route:'room-options/equipements'},
 // // {icon:'task',name:'Interventions',route:'/front-desk/tasks'},
 // // {icon:'warning_amber',name: 'Interventions signalés',route: 'house-keeping/reports',notifications:5},
 // // {icon:'task',name:'Statistiques interventions',route:'/front-desk/interventions/bilan'},
 // {icon:'manage_accounts',name:'House Maids',route: 'house-keeping/house-maids'},
 // {icon:'task',name:'Add room Task',route:'front-desk/room-add-task'},
 // // {icon:'group_add',name:'Groupes de ménage',route: 'house-keeping/house-maids-groupes'},
 // // {icon:'tune',name:'Paramétres de ménage',route: 'house-keeping/house-maids-parametres'},
 // // {icon:'cleaning_services',name:'Entretien ménager',route: 'house-keeping/house-maids-interventions'},
 // // {icon:'warning_amber',name: 'Ménage urgent',route: 'house-keeping/urgent-clean',notifications:5},
 // // {icon:'event',name: 'Calendrier de ménage',route: 'house-keeping/calendar-clean'},

 // ],
 // // [
 // // {icon:'task',name:'Houskeeping Taskes',route:'/front-desk/tasks'},
 // // {icon:'done_all',name: 'Update Room Status After Cleaning',route: 'house-keeping/reports'},
 // // {icon:'local_offer',name:'Speciale Packages',route:'/front-desk/reservationslist'},
 // // {icon:'gavel',name:'Rules And Restrution',route:'/front-desk/reservationslist'},
 // // ],
 // //Report
 // [ {icon:'today',name:'Genarating Daily Reports',route:'/front-desk/dashboard'},
 // {icon:'description',name:'Genarating Financcial Reports',route:'/front-desk/reservations-management'},
 // {icon:'analytics',name:'Performance Reports',route:'/front-desk/reservationslist'},
 // {icon:'bar_chart',name:'Custom Reports As Needed',route:'/front-desk/reservationslist'},
 // ],
 // //Revenue
 // [ {icon:'monetization_on',name:'Pricing Based On Demand',route:'/front-desk/dashboard'},
 // {icon:'airline_seat_individual_suite',name:'Overbooking Strategies',route:'/front-desk/reservations-management'},
 // {icon:'show_chart',name:'Forcasting Revenue And Demand',route:'/front-desk/reservationslist'},
 // {icon:'trending_up',name:'Tracking competitor Pricing And Marcket Demand ',route:'/front-desk/reservationslist'},
 // ],
 // //Payement
 // [ {icon:'account_balance_wallet',name:'Processing Pre-Arrivals-Deposits, and Cancellations',route:'/front-desk/dashboard'},
 // {icon:'description',name:'Generating Invoices And Folis',route:'/front-desk/reservations-management'},
 // {icon:'money_off',name:'Refund And Correction',route:'/front-desk/reservationslist'},

 // ],
 // //Rates
 // [ {icon:'account_balance_wallet',name:'Room Rates, and Cancellations',route:'/front-desk/dashboard'},
 // {icon:'description',name:'Adjusting Rates',route:'/front-desk/reservations-management'},
 // {icon:'local_offer',name:'Speciale Packages',route:'/front-desk/reservationslist'},
 // {icon:'gavel',name:'Rules And Restrution',route:'/front-desk/reservationslist'},

 // ],

 // /////////////////////

 // [
 // {icon:'room_preferences',name:'chambres',route:'room-options'},
 // {icon:'local_shipping',name:'équipements',route:'room-options/equipements'},
 // {icon:'fullscreen',name:'Indica
 //
 //
 // teur des chambres ',route:'front-desk/plan-2d'},

 // ],
 // //House
 // [
 // {icon:'task',name:'Interventions',route:'/front-desk/tasks'},
 // {icon:'warning_amber',name: 'Interventions signalés',route: 'house-keeping/reports',notifications:5},
 // {icon:'task',name:'Statistiques interventions',route:'/front-desk/interventions/bilan'},
 // {icon:'manage_accounts',name:'Femmes de ménage',route: 'house-keeping/house-maids'},
 // {icon:'group_add',name:'Groupes de ménage',route: 'house-keeping/house-maids-groupes'},
 // {icon:'tune',name:'Paramétres de ménage',route: 'house-keeping/house-maids-parametres'},
 // {icon:'cleaning_services',name:'Entretien ménager',route: 'house-keeping/house-maids-interventions'},
 // {icon:'warning_amber',name: 'Ménage urgent',route: 'house-keeping/urgent-clean',notifications:5},
 // {icon:'event',name: 'Calendrier de ménage',route: 'house-keeping/calendar-clean'},

 // ],
 // [
 // // {icon:'book_online',name:'Réservations et types',route:''},
 // {icon:'show_chart',name:'Clients et revenus',route:'front-desk/dashboard/clients'},
 // ],
 // [
 // {icon:'donut_large',name:'Dashboard',route:'/front-desk/dashboard'},

 // {icon:'add_circle',name:'Create Booking',route:'/front-desk/reservations-management',notifications:10},
 // {icon:'event_available',name:'Bookings',route:'/front-desk/reservationslist',notifications:10},

 // // {icon:'book_online',name:'Réservations et types',route:'/front-desk/reservation'},

 // {icon:'check_circle',name:'Check In',route:'/front-desk/check-in',notifications:25},
 // {icon:'home',name:'In House',route:'/front-desk/in-House',notifications:10},
 // {icon:'exit_to_app',name:'Check Out',route:'/front-desk/check-out',notifications:10},

 // {icon:'calendar_today',name:'Room Calendar',route:'/front-desk/rooms'},
 // {icon:'schedule',name:'Appointment',route:'front-desk/rendez-vous'},
 // {icon:'search',name:'Lost and Found',route:'/front-desk/lost&found'},
 // ],

 // [
 // {
 // icon: 'add',
 // name: 'New External Command',
 // route: '/front-desk/addCommande',
 // },
 // {icon:'done',name: "Validation of Purchase Orders",route: 'front-desk/achat'},
 // {icon:'request_quote',name: "Delivery",route: 'front-desk/delivery'},
 // {icon:'inventory_2',name: 'Article',route: 'back-office/articleManagement'},
 // {icon:'forklift',name: 'Fournisseur',route: ''},

 // {icon:' fact_check',name: 'Commandes',route: ''},
 // {icon:'warehouse',name: 'Stock',route: ''},
 // {icon:'receipt ',name: 'Réception',route: ''},
 // {icon:'attach_money ',name: 'Factures',route: ''},

 // //{icon:'event',name:'POS',route:'house-keeping/pos'},
 // ]
 // ];
 sideBarB2BMatrix: any = [
 //Reservation
 [

 {
 icon: "fas fa-calendar-plus",
 name: "New Reservation",
 route: "/front-desk/reservations-management",
 children: [],
 },
 {
 icon: "fas fa-list-alt",
 name: "Orders",
 route: "/front-desk/orders",
 children: [],
 },
 {
 icon: "fas fa-file-invoice",
 name: "Invoices",
 route: "/front-desk/invoices",
 children: [],

 },
 ],
 ];
 sideBarMatrix: any = [];
 sideBarHotelMatrix: any = [
 //Reservation
 [
 {
 icon: "fas fa-chart-line",
 name: "Dashboard",
 route: "/main/dashboardAdmin",
 children: [],
 },
 {
 icon: "fas fa-calendar-plus",
 name: "New Reservation",
 route: "/front-desk/reservations-management",
 children: [],
 },
 {
 icon: "fas fa-edit",
 name: "Reservations",
 route: "/front-desk/reservationslist",
 children: [],
 },
 {
 icon: "fas fa-calendar",
 name: "Calendar",
 route: "/front-desk/calendar",
 children: [],
 },
 ],
 //Front Desk
 [
 {
 icon: "fas fa-sign-in-alt",
 name: "Check In",
 route: "/front-desk/check-in",
 children: [],
 },
 {
 icon: "fas fa-home",
 name: "In House",
 route: "/front-desk/in-House",
 children: [],
 },
 {
 icon: "fas fa-sign-out-alt",
 name: "Check Out",
 route: "/front-desk/check-out",
 children: [],
 },
  {
 icon: "fas fa-home",
 name: "Check Out Reservation",
 route: "/front-desk/checkoutReservation",
 children: [],
 },
 
 {
 icon: "fas fa-calendar-times",
 name: "Cancelation & No Show",
 route: "/front-desk/Cancellation&Noshow",
 children: [],
 },
 {
  icon: "fas fa-sync-alt",
  name: "Integrations",
  route: "/front-desk/Integrations",
  children: [],
 },
 
 ],
 //backOffice
 [
 {
 icon: "settings",
 name: "Settings",
 children: [

 {
 icon: "fas fa-user",
 name: "Users",
 route: "/front-desk/BackOfice/Users",
 },
 {
 icon: "fas fa-cogs",
 name: "Services",
 route: "/front-desk/BackOfice/Services",
 },
 // {
 // icon: "file_copy",
 // name: "Connected Pos",
 // route: "/front-desk/BackOfice/ConnectedPos",
 // },
 {
 icon: "fas fa-truck",
 name: "Suppliers",
 route: "/front-desk/BackOfice/Suppliers",
 },
 
 {
 icon: "fas fa-list",
 name: "List Product",
 route: "/front-desk/BackOfice/list",
 },
 {
 icon: "fas fa-file-alt",
 name: "Add Article",
 route: "/front-desk/BackOfice/Creation-Article",
 },
 {
 icon: "fas fa-cube",
 name: "Add Product",
 route: "/front-desk/BackOfice/Products",
 },
 {
 icon: "fas fa-cube",
 name: "Familly",
 route: "/front-desk/BackOfice/familly",
 },

 {
 icon: "fas fa-cogs",
 name: "Add Services",
 route: "/front-desk/BackOfice/Creation-Prestations",
 },
 ],
 },
 {
 icon: "build",
 name: "BO Processing",
 children: [
 // and for the second menu for traitement i want this in sous menu
 {
 icon: "fas fa-check-circle",
 name: "Purchase List",
 code:0,
 route: "/front-desk/BackOfice/List-Achat",
 },
 {
 icon: "fas fa-plus",
 name: "New Purchase",
 code:1,
 route: "/front-desk/BackOfice/OrderSuplier",
 },
 {
 icon: "fas fa-check-circle",
 name: "Validate Purchase",
 code:1,
 route: "/front-desk/BackOfice/ServiceAchat",
 },
 {
 icon: "fas fa-check-circle",
 name: "Validation of Purchase Orders",
 code:1,
 route: "/front-desk/BackOfice/achat",
 },

 {
 icon: "fas fa-truck",
 name: "Delivery",
 code:1,
 route: "/front-desk/BackOfice/delivery",
 }, 
 {
 icon: "fas fa-check-square",
 name: "Confirm Delivery",
 code:1,
 route: "/front-desk/BackOfice/confirm-delivery",
 },

 {
 icon: "fas fa-plus",
 name: "Add Stock",
 code:2,
 route: "/front-desk/BackOfice/InternalOrder",
 },
 {
 icon: "fas fa-truck-moving",
 name: "Stock Transfer",
 code:2,
 route: "/front-desk/BackOfice/StockTransfer",
 },
 {
 icon: "fas fa-cogs",
 name: "Control",
 code:2,
 route: "/front-desk/BackOfice/ValidateOrderInternal",
 },

 {
 icon: "fas fa-exchange-alt",
 name: "Movement Stock",
 code:3,
 route: "/front-desk/BackOfice/StockStatus",
 },
 {
 icon: "fas fa-cubes",
 name: "Inventory",
 code:3,
 route: "/front-desk/BackOfice/CorrectionStock",
 },
 ],
 },
 {
 icon: "description",
 name: "Report",
 children: [
 // and for menu of rapport i want this in the sous menu
 {
 icon: "fas fa-archive",
 name: "Rapprochement Stock",
 route: "/front-desk/BackOfice/stocks",
 }, 
 {
 icon: "table-fas fa-chart-line",
 name: "Board",
 route: "/front-desk/BackOfice/Editing",
 },
 {
 icon: "fas fa-exchange-alt",
 name: "Consumption",
 route: "/front-desk/BackOfice/Consommation",
 },
 {
 icon: "fas fa-credit-card",
 name: "Cardex",
 route: "/front-desk/BackOfice/transactionstock",
 },
 {
 icon: "fas fa-chart-bar",
 name: "Stock Out Report",
 route: "/front-desk/BackOfice/Prelevement",
 },
 {
 icon: "fas fa-check-circle",
 name: "Transfer Status",
 route: "/front-desk/BackOfice/StateTransfer",
 },
 {
 icon: "fas fa-list-alt",
 name: "Entry Status",
 route: "/front-desk/BackOfice/StateEntries",
 },
 {
 icon: "fas fa-list-alt",
 name: "Asset Status",
 route: "/front-desk/BackOfice/StateAssets",
 },
 {
 icon: "fas fa-list-alt",
 name: "Correction Status",
 route: "/front-desk/BackOfice/StatusCorrections",
 },
 {
 icon: "fas fa-list-alt",
 name: "Purchase Report",
 route: "/front-desk/BackOfice/Purchase-Report",
 },
 {
 icon: "fas fa-list-alt",
 name: "Internal Report",
 route: "/front-desk/BackOfice/InternalReport",
 },
 {
 icon: "fas fa-list-alt",
 name: "Pending Stock Issue",
 route: "/front-desk/BackOfice/Stock-Unconfirmed",
 },
 {
 icon:"fas fa-lock",
 name:"Close & Open",
 route:"/front-desk/BackOfice/PageOfClose"
 },
 {
 icon: "fas fa-archive",
 name: "Stock Physical",
 route: "/front-desk/BackOfice/Stock/Physical",
 },
 {
 icon: "fas fa-archive",
 name: "Stock Theoretical",
 route: "/front-desk/BackOfice/Stock/Theoretical",
 },
  {
 icon: "fas fa-archive",
 name: "Tracking BP",
 route: "/front-desk/BackOfice/Stock_Movement_Tracking",
 },
 ],
 },
 ],
 //Houskeeping RoomStatus
 [
 {
 icon: "fas fa-tools",
 name: "Configuration Room",
 route: "house-keeping/room-options",
 children: [],
 },

 {
 icon: "fas fa-bed",
 name: "Room Status",
 route: "front-desk/RoomStatus",
 children: [],
 },
 {
  icon: "fas fa-exchange-alt",
  name: "Delogemnt",
  route: "front-desk/delogemnt",
  children: [],
  },
 
 {
 icon: "fas fa-list-alt",
 name: "Report",
 route: "front-desk/Housekeeping-Report",
 children: [],
 },
 {
 icon: "fas fa-list-alt",
 name: "Verification",
 route: "front-desk/Housekeeping-Report-Control",
 children: [],
 },
 {
 icon: "fas fa-list-alt",
 name: "Matching-Report",
 route: "front-desk/Matching-Report",
 children: [],
 },

 ],

 //Report
 [
 {
 icon: "today",
 name: "Genarating Front Desk Reports",
 route: "/front-desk/dashboard",
 
 },
 {
  icon: "today",
  name: "KPI Dashboard",
  route: "/front-desk/dashKpi",
  
  },
  {
    icon: "today",
    name: "Nationalité Dashboard",
    route: "/front-desk/customerOver",
    
  },
  {
    icon: "today",
    name: "Reception Planning",
    route: "/front-desk/reception",
    
  },
  {
    icon: "today",
    name: "Logs",
    route: "/front-desk/logs",
    
  },
 {
 icon: "report",
 name: "Extra Sales",
 route: "/reports/extra-sales",
 
 },
 {
 icon: "description",
 name: "Genarating Financcial Reports",
 route: "/front-desk/Reports",
 children: [],
 },
 {
 icon: "analytics",
 name: "Performance Reports",
 route: "/front-desk/reservationslist",
 children: [],
 },
 {
 icon: "bar_chart",
 name: "Custom Reports As Needed",
 route: "/front-desk/reservationslist",
 children: [],
 },
 ],
 //Revenue
 [
 {
 icon: "monetization_on",
 name: "Pricing Based On Demand",
 route: "/front-desk/dashboard",
 children: [],
 },
 {
 icon: "airline_seat_individual_suite",
 name: "Overbooking Strategies",
 route: "/front-desk/reservations-management",
 children: [],
 },
 {
 icon: "show_chart",
 name: "Forcasting Revenue And Demand",
 route: "/front-desk/reservationslist",
 children: [],
 },
 {
 icon: "trending_up",
 name: "Tracking competitor Pricing And Marcket Demand ",
 route: "/front-desk/reservationslist",
 children: [],
 },
 ],
 //Payement
 [
 {
 icon: "fas fa-money-check",
 name: "Payments",
 route: "/front-desk/List-Payments",
 children: [],
 },
 

 {
 icon: "fas fa-file-invoice",
 name: "Invoices",
 route: "/front-desk/ListFactures",
 children: [],

 },
{
 icon: "fas fa-file-invoice",
 name: "Not Invoiced",
 route: "/front-desk/Without_Facture",
 children: [],

 },
 {
 icon: "fas fa-file-invoice",
 name: "Sent to bavel",
 route: "/front-desk/Sent_to_bavel",
 children: [],

 },
 {
 icon: "fas fa-file-invoice",
 name: "Exchange",
 route: "/front-desk/Exchange",
 children: [],

 },
 {
 icon: "fas fa-exchange-alt", 
 name: "Exchange Slip", 
 route: "/front-desk/Bordereau",
 children: [],
 }
 
 ],
 [],
 [
 //end of day childrens

 {icon: "update", name: "Control", route: "/front-desk/End-of-Day" ,
 children: []},
 {
 icon: "history",
 name: "History",
 route: "front-desk/End-of-Day-history",
 children: []
 },
 ],
 [

 
 {
 icon: "fas fa-users",
 name: "Users",
 route: "/admin/users-menus",
 children: [],
 },

 
 {
 icon: "fas fa-user-shield",
 name: "Activity Report",
 route: "/front-desk/Report-Activity",
 children: [],
 },
 {
 icon: "fas fa-money-bill-wave",
 name: "Budgets",
 route: "/front-desk/Budgets-management",
 children: [],
 },
{
 icon: "fas fa-bed",
 name: "Room Management",
 route: "/front-desk/room-management",
 children: [],
 },
  {
 icon: "fas fa-file-invoice-dollar",
 name: "Payment Rules",
 route: "/front-desk/PaymentRules",
 children: [],
 },
 ],
 [
 // Compta
 {
 icon: "fas fa-file-invoice",
 name: "Accounting Report",
 route: "/front-desk/Accounting_Report",
 children: [],

 },
 // Compta
 {
 icon: "fas fa-file-invoice",
 name: "Analysis Invoice",
 route: "/front-desk/Analyse-Invoice",
 children: [],

 },
 
 // {
 // icon: "fas fa-bars",
 // name: "Menu",
 // route: "/admin/menus",
 // children: [],
 // },
 ],
 [
 // Crm
 {
 icon: "fas fa-users", // 👥 pour "Customer"
 name: "Customer",
 route: "/front-desk/Customers",
 children: [],
 }, 
 {
 icon: "fas fa-list-alt",
 name: "Commande",
 route: "/front-desk/orders",
 children: [],
 },
 {
 icon: "fas fa-exchange-alt", // 🔁 pour "Exchange rate"
 name: "Exchange rate",
 route: "/front-desk/exchange",
 children: [],
 },
 {
 icon: "fas fa-layer-group", // 🧩 pour "Segment"
 name: "Segment",
 route: "/front-desk/Segment",
 children: [],
 }
 // {
 // icon: "fas fa-bars",
 // name: "Menu",
 // route: "/admin/menus",
 // children: [],
 // },
 ],
 [
 // AUDIT 
 {
 icon: "fas fa-clipboard-list",
 name: "Audit List",
 route: "/front-desk/audit-list",
 children: [],
 },
 {
 icon: "fas fa-file-signature",
 name: "Create Audit",
 route: "/front-desk/audit-admin",
 children: [],
 },
 
 ],
 [
   {
  icon: "fas fa-file-signature",
  name: "STDN Declaration",
  route: "/front-desk/stdn-declaration",
  children: [],
  },
 ],
[
  {
    icon: "fas fa-file-signature",
    name: "Plan Comptable",
    route: "/front-desk/Plan",
    children: [],
    },
   {
  icon: "fas fa-file-signature",
  name: "Saisie de règlement",
  route: "/front-desk/Create-Payment",
  children: [],
  },
  {
  icon: "fas fa-file-signature",
  name: "les règlements",
  route: "/front-desk/List_Payments",
  children: [],
  },
  {
  icon: "fas fa-file-signature",
  name: "Lettrage",
  route: "/front-desk/Customer_reconciliation",
  children: [],
  },
  {
  icon: "fas fa-file-signature",
  name: "Grand Livre",
  route: "/front-desk/Grand_Livre",
  children: [],
  },
  {
  icon: "fas fa-file-signature",
  name: "Journal",
  route: "/front-desk/Journal",
  children: [],
  },
 ],

 ];





 



 SIdbareMatriceRoles: any[] = [];
 public extraParameter: any;
 public langue: string;
 private groupIdSubject = new BehaviorSubject<number>(null);
 groupId$ = this.groupIdSubject.asObservable();
 user:any;
 constructor(public globals: ThemeOptions,
 private activatedRoute: ActivatedRoute,
 private router: Router,
 private renderer: Renderer2,
 private keyCloakService:KeycloakService,
 private languageService : LanguageService,
 private reservationService:ReservationService,
 ) {
 this.user = JSON.parse(localStorage.getItem('userDetails'));

 } 

 
 @select('config') public config$: Observable<any>;

 private newInnerWidth: number;
 private innerWidth: number;
 activeId = 'dashboardsMenu';
 activeId1 = 'elementsMenu';

 toggleSidebar() {
 this.globals.toggleSidebar = !this.globals.toggleSidebar;
 }

 housekeepingSubMenuOpen = false;
 reservationSubMenuOpen = false;
 frontDSubMenuOpen = false;
 backSubMenuOpen = false;
 backSubMenuOpenN = false;
 reportingSubMenuOpen= false;
 paymentSubMenuOpen= false;
 endSubMenuOpen= false;
 subMenuOpen: boolean = false;
 isSubMenuOpen : boolean= false;
 is1SubMenuOpen : boolean= false;
 is2SubMenuOpen : boolean= false;
 adminSubMenuOpen = false;
 allowedUserIds:any;
 currentUserId:any;
 canExchangeRate:any; 

 toggleis1SubMenu(category: string): void {
 this.is1SubMenuOpen = !this.is1SubMenuOpen;
 }
 toggleis2SubMenu(category: string): void {
 this.is2SubMenuOpen = !this.is2SubMenuOpen;
 }
 toggleisSubMenu(category: string): void {
 this.isSubMenuOpen = !this.isSubMenuOpen;
 }
 
 
 selectedItem: string;

 selectItem(item: string) {
 this.selectedItem = item;
 }
 
 // Ajoutez d'autres méthodes de sélection pour les autres éléments de sous-menu de la même manière
 
 
 
 
 toggleSubMenu() {
 this.subMenuOpen = !this.subMenuOpen;
 }

 getArrowIconClass() {
 return this.subMenuOpen ? 'arrow-down' : 'arrow-right';
 }
 
 toggleEndSubMenu(){
 this.endSubMenuOpen= !this.endSubMenuOpen;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false ;
 this.CrmSubMenuOpen = false;
 }


 togglePaymentSubMenu(index:any){
 this.index = index;
 this.paymentSubMenuOpen = !this.paymentSubMenuOpen;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.endSubMenuOpen = false
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false ;
 this.CrmSubMenuOpen = false;


 }

toggleSidebarVisibility(): void {
  this.isSidebarVisible = !this.isSidebarVisible;
  this.globals.toggleSidebar = !this.isSidebarVisible;
  this.globals.sidebarVisible = this.isSidebarVisible;
  
  if (!this.isSidebarVisible) {
    this.renderer.addClass(document.body, 'sidebar-collapsed');
  } else {
    this.renderer.removeClass(document.body, 'sidebar-collapsed');
  }
}
 toggleReportingSubMenu(){
 this.reportingSubMenuOpen= !this.reportingSubMenuOpen;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;

 this.comptaSubMenuOpen = false ;
 this.CrmSubMenuOpen = false;
 this.ReconcilliationSubMenuOpen = false;


 }

 toggleBackSubMenu(index:any){
 this.index = index;
 this.backSubMenuOpen = !this.backSubMenuOpen;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false ;
 this.CrmSubMenuOpen = false;
 this.ReconcilliationSubMenuOpen = false;


 }
 
 toggleBackNSubMenu(){
 this.backSubMenuOpenN = !this.backSubMenuOpenN;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.ReconcilliationSubMenuOpen = false;
 }
 toggleHousekeepingSubMenu(index:any) {
 this.index = index;
 this.housekeepingSubMenuOpen = !this.housekeepingSubMenuOpen;
 this.reservationSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false ;
 this.CrmSubMenuOpen = false;
 this.ReconcilliationSubMenuOpen = false;


 }
 toggleReseaSubMenu(index:any) {
 this.index = index
 console.log("this.index",this.index);
 this.reservationSubMenuOpen = !this.reservationSubMenuOpen;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false ;
 this.CrmSubMenuOpen = false;
 this.ReconcilliationSubMenuOpen = false;


 }
 toggleFrontSubMenu(index:any) {
 this.index = index;
 this.frontDSubMenuOpen = !this.frontDSubMenuOpen;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false ;
 this.CrmSubMenuOpen = false;
 this.ReconcilliationSubMenuOpen = false;


 }
 toggleComptaSubMenu(index:any) {
 this.index = index;
 this.frontDSubMenuOpen = false;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = ! this.comptaSubMenuOpen;
 this.CrmSubMenuOpen = false;
 this.ReconcilliationSubMenuOpen = false;


 }


  toggleReconcilliationSubMenu(index:any) {
 this.index = index;
 this.frontDSubMenuOpen = false;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false;
 this.CrmSubMenuOpen = false;
 this.ReconcilliationSubMenuOpen = ! this.ReconcilliationSubMenuOpen


 }


 
 toggleCrmSubMenu(index:any) {
 this.index = index;
 this.frontDSubMenuOpen = false;
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.backSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false;
 this.CrmSubMenuOpen = !this.CrmSubMenuOpen;
 this.ReconcilliationSubMenuOpen = false;


 }

 openNewTab(url:string){
 window.open(url,'_blank');
 }
 sidebarHover() {
 this.globals.sidebarHover = !this.globals.sidebarHover;
 }

 ngOnInit() {
 setTimeout(() => {
 const userDetails = JSON.parse(localStorage.getItem("userDetails"));
 this.allowedUserIds = new Set<number>([7,6,20]);
 this.currentUserId = JSON.parse(localStorage.getItem('userDetails') || '{}')?.userId;
 this.canExchangeRate = this.allowedUserIds.has(this.currentUserId);
 if (userDetails && userDetails.group) {
 this.groupId = userDetails.group.groupId;
 if (userDetails && userDetails.preferredGroups && userDetails.preferredGroups.length !== 0) {
 userDetails.preferredGroups.forEach((group) => {
 if (group.groupId === 0) {
 this.showedChaifer = true;
 return; // Use return instead of break inside forEach
 }
 });
 }
 
 // Any additional logic you want to execute after setting groupId
 }
 }, 800);
 this.logCurrentIndexAndItems();
 console.log("groupId", this.groupId);
 
 this.languageService.initLanguage();
 this.langue = this.languageService.userLanguage;
 // this.User = JSON.parse(localStorage.getItem("userDetails"));
 // this.globals.toggleSidebar = false;
 // const currentURL = window.location.href;
 this.Disabled = this.User?.roles[0].activatedMenu.split(';').map(item => {
 const parts = item.split(':');

 this.indexo = parseInt(parts[0], 10)
 console.log("this.indexo", this.indexo);
 return parseInt(parts[1], 10);
 });
 if(this.Disabled!== undefined && this.Disabled.length !== 0){
 console.log("this.Disabled Checked",this.Disabled);
 }

 this.checkWindowSize();
 this.globals.toggleSidebar = false;
 const currentURL = window.location.href;
 this.User = JSON.parse(localStorage.getItem("userDetails"));
 console.log("USER", this.User);
 if (this.User.customerId !== null){
 this.router.navigateByUrl('/front-desk/reservations-management');
 this.sideBarMatrix = this.sideBarB2BMatrix;
 }else{
 this.sideBarMatrix = this.sideBarHotelMatrix;
 }
 // Check if User and roles are defined before accessing them
 if (this.User && this.User.roles && this.User.roles.length > 0) {
 // Access roles[0] and activatedMenu only if they are defined
 console.log("this.User.roles.", this.User.roles);
 this.Disabled = this.User.roles[0].activatedMenu
 .split(";")
 .map((item) => {
 const parts = item.split(":");
 this.indexo = parseInt(parts[0], 10);
 console.log("this.indexo", this.indexo);
 return parseInt(parts[1], 10);
 });
 if (
 this.indexo !== null &&
 this.indexo !== undefined &&
 this.Disabled.length !== 0
 ) {
 this.SIdbareMatriceRoles = [];
 this.sideBarMatrix[this.indexo].forEach((item, j) => {
 this.Disabled.forEach((k) => {
 if (j === k) {
 this.SIdbareMatriceRoles.push(item);
 }
 });
 });
 }
 } else {
 // Handle the case where User or roles are undefined
 console.error("User, roles, or roles[0] is undefined");
 // You might want to set this.Disabled to a default value or handle this case appropriately
 }

 console.log(this.Disabled);
 if (this.Disabled.length !== 0) {
 this.refreshSideBar()
 this.checked = false;
 }
 // Check if the URL contains "BackOfice"
 // this.selectedItem(0);
 // if (currentURL.includes("BackOfice")) {
 // this.selectedItem(2);
 // } else {
 // console.log("The URL does not contain 'BackOfice'.");
 // }
 setTimeout(() => {
 this.innerWidth = window.innerWidth;
 if (this.innerWidth < 1200) {
 this.globals.toggleSidebar = true;
 }
 });
 //console.log(this.activatedRoute.snapshot.firstChild)
 this.extraParameter =
 this.activatedRoute.snapshot.firstChild.data.extraParameter;
 }

 @HostListener("window:resize", ["$event"])
 onResize(event) {
 this.newInnerWidth = event.target.innerWidth;
 this.checkWindowSize();
 if (this.newInnerWidth < 1200) {
 this.globals.toggleSidebar = true;
 } else {
 this.globals.toggleSidebar = false;
 }
 }
 clickedItem: string | null = null;
 selectedName: string | null = null;

 setClickedItem(name: string): void {
 this.clickedItem = name;
 }

 resetClickedItem(): void {
 this.clickedItem = null;
 }

 // selectedItem(index: number, childIndex?: number): void {
 // // If a child index is provided, use it to access the child route.
 // if (
 // childIndex !== undefined &&
 // this.sideBarMatrix[index]?.children?.[childIndex]
 // ) {
 // const childRoute = this.sideBarMatrix[index].children[childIndex].route;
 // this.router.navigateByUrl(childRoute).catch((err) => {
 // console.error("Navigation error:", err);
 // });
 // } else {
 // // Toggle the checked state and navigate to the parent route if no childIndex is provided.
 // this.index = index;
 // this.selectedIndex = index;
 // console.log("Selected index:", this.index);

 // if (this.indexo !== undefined) {
 // this.checked = this.index !== this.indexo;
 // console.log("Checked:", this.checked);
 // }

 // if (this.sideBarMatrix[this.index]?.[0]?.route) {
 // const route = this.sideBarMatrix[this.index][0].route;
 // this.router.navigateByUrl(route).catch((err) => {
 // console.error("Navigation error:", err);
 // });
 // }
 // }

 // // Toggle submenu visibility for the clicked item
 // if (this.sideBarMatrix[index]?.children) {
 // this.sideBarMatrix[index].showChildren =
 // !this.sideBarMatrix[index].showChildren;
 // }
 // }

 selectedItenBack(index: number): void {
 this.indexBack = index;
 }
 SELEctedItem(i: number): void {
 this.selectedListItemIndex = i;
 console.log("selectedListItemIndex", this.selectedListItemIndex);
 }
 checkWindowSize(): void {
 const windowWidth = window.innerWidth;
 const shouldCollapse = windowWidth < 1112;

 if (shouldCollapse) {
 this.renderer.addClass(document.body, "navbar-collapsed");
 } else {
 this.renderer.removeClass(document.body, "navbar-collapsed");
 this.isNavbarCollapsed = true; // Collapse the navbar content if expanded
 }
 }

 logout() {
 console.log(this.keyCloakService.keycloakEvents$);
 this.keyCloakService.logout();
 }

 changeLanguage(language: string) {
 console.log("la langue est : ", language);
 this.languageService.setLanguage(language);
 }
 isArray(item: any): boolean {
 return Array.isArray(item);
 }
 // Method to toggle submenu visibility
 navigate(route: string): void {
 this.router.navigateByUrl(route).catch((err) => {
 console.error("Error during navigation", err);
 });
 }



 logCurrentIndexAndItems() {
 console.log(
 "Current index:",
 this.index,
 "Current items:",
 this.sideBarMatrix[this.index]
 );
 }

 trackByFn(index, item) {
 return item.id; // or index
 }

 handleClick(item) {
 // Toggle the boolean property 'showChildren'
 item.showChildren = !item.showChildren;
 // If there are no children, navigate
 if (!item.children?.length) {
 this.router.navigateByUrl(item.route).catch((err) => {
 console.error("Navigation error:", err);
 });
 }
 }

 refreshSideBar() {
 let Parametrage: any[] = [];
 let Traitement: any[] = [];
 let rapport: any[] = [];
 let d = 0;
 
 if (this.index == 2 || this.indexo == 2) {
 this.Disabled.forEach(num => {
 d++;
 if (num <= 6) {
 Parametrage.push(this.sideBarMatrix[2][0].children[num]);
 } else if (num >= 7 && num <= 17) {
 Traitement.push(this.sideBarMatrix[2][1].children[num - 7]);
 } else if (num >= 18) {
 rapport.push(this.sideBarMatrix[2][2].children[num - 18]);
 }
 
 if (d === this.Disabled.length) {
 this.sideBarMatrix[2][2].children = rapport;
 this.sideBarMatrix[2][1].children = Traitement;
 this.sideBarMatrix[2][0].children = Parametrage;
 
 // // Navigate to the first found item
 // if (Parametrage.length > 0) {
 // const firstItemRoute = Parametrage[0].route; // Assuming your item object has a 'route' property
 // this.router.navigateByUrl(firstItemRoute);
 // } else if (Traitement.length > 0) {
 // const firstItemRoute = Traitement[0].route;
 // this.router.navigateByUrl(firstItemRoute);
 // } else if (rapport.length > 0) {
 // const firstItemRoute = rapport[0].route;
 // this.router.navigateByUrl(firstItemRoute);
 // }
 }
 });
 }
 }
 
 async sendToSupport(): Promise<void> {
 const supportEmail = 'support@fractalite.com';
 const subject = encodeURIComponent('Demande de support');
 const body = encodeURIComponent('Bonjour,\n\nJe rencontre un problème avec ...');
 
 // URL Gmail pour composer un nouveau message
 const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&to=${supportEmail}&su=${subject}&body=${body}`;
 
 try {
 // Ouvrir Gmail dans un nouvel onglet
 window.open(gmailComposeUrl, '_blank');
 await this.PutEveznt("Sent to RoomEase Support", { auditEventTypeId: 37 });
 } catch (error) {
 console.error('Erreur lors de l\'ouverture de Gmail', error);
 alert('Impossible d\'ouvrir Gmail. Vérifiez votre connexion Internet.');
 }
 }

 async PutEveznt(message:any,type:any){
 this.EventNew.user = JSON.parse(localStorage.getItem("userDetails"));
 this.EventNew.message = message;
 this.EventNew.type = type,
 this.EventNew.itemId = null;
 this.EventNew.itemNumber = null;
 this.EventNew.detail = null;

 //put event test 
 await this.reservationService.puteventNote(this.EventNew).toPromise();
}
 
marketingSubMenuOpen: boolean = false;
stdnSubMenuOpen: boolean = false;

toggleMarketingSubMenu(index: any) {
 this.index = index;
 this.marketingSubMenuOpen = !this.marketingSubMenuOpen;

 // fermer tous les autres menus (copié sur tes autres toggles)
 this.reservationSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.backSubMenuOpen = false;
 this.backSubMenuOpenN = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.adminSubMenuOpen = false;
 this.comptaSubMenuOpen = false;
 this.CrmSubMenuOpen = false;
}

toggleStdnSubMenu(index: any) {
  this.index = index;
  this.stdnSubMenuOpen = !this.stdnSubMenuOpen;

  // Close all other menus
  this.reservationSubMenuOpen = false;
  this.housekeepingSubMenuOpen = false;
  this.backSubMenuOpen = false;
  this.backSubMenuOpenN = false;
  this.reportingSubMenuOpen = false;
  this.paymentSubMenuOpen = false;
  this.frontDSubMenuOpen = false;
  this.endSubMenuOpen = false;
  this.adminSubMenuOpen = false;
  this.comptaSubMenuOpen = false;
  this.CrmSubMenuOpen = false;
  this.marketingSubMenuOpen = false;
}

toggleAdminSubMenu() {
 this.adminSubMenuOpen = !this.adminSubMenuOpen;

 this.reservationSubMenuOpen = false;
 this.frontDSubMenuOpen = false;
 this.backSubMenuOpen = false;
 this.housekeepingSubMenuOpen = false;
 this.reportingSubMenuOpen = false;
 this.paymentSubMenuOpen = false;
 this.endSubMenuOpen = false;
 this.marketingSubMenuOpen = false;
 this.comptaSubMenuOpen = false;
 this.CrmSubMenuOpen = false;
this.stdnSubMenuOpen = false; 
}

activeReservationIndex = 0;
activeFrontDeskIndex = 1;
activeBackOfficeIndex = 2;
activeHousekeepingIndex = 3;
activeReportingIndex = 4;
activePaymentIndex = 5;
activeAccountingIndex = 6;
activeEndOfDayIndex = 7;
activeMarketingIndex = 8;
activeAdminIndex = 9;
activeComptaIndex = 10;
activeCrmIndex = 11;
activeStdnIndex = 13;

// toggleAdminSubMenu(index:any) {
// this.index = index
// console.log("this.index",this.index);
// this.adminSubMenuOpen = !this.adminSubMenuOpen;
// this.reservationSubMenuOpen = false;
// this.housekeepingSubMenuOpen = false;
// this.backSubMenuOpenN = false;
// this.backSubMenuOpen = false;
// this.reportingSubMenuOpen = false;
// this.paymentSubMenuOpen = false;
// this.frontDSubMenuOpen = false;
// this.endSubMenuOpen = false;
// this.comptaSubMenuOpen = false ;
// this.CrmSubMenuOpen = false;

// }
 

}